import { render, staticRenderFns } from "./TransferDiscipleModal.vue?vue&type=template&id=2ff7dc5c&"
import script from "./TransferDiscipleModal.vue?vue&type=script&lang=js&"
export * from "./TransferDiscipleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports